import React from 'react';

// SOCIAL

export const SOCIAL_FACEBOOK = (
  <g>
    <path d='M34.3,11.1h9V0.5h-9c-6.9,0-12.4,5.5-12.4,12.4v5.3h-7.1V29h7.1v28.5h10.6V29h9l1.8-10.6H32.7v-5.3C32.7,12.1,33.5,11.1,34.3,11.1z' />
  </g>
);

export const SOCIAL_TWITTER = (
  <g>
    <path
      d='M57.5,10.8c-2.2,1-4.3,1.7-6.7,1.9c2.4-1.4,4.3-3.8,5.3-6.7c-2.4,1.4-4.8,2.4-7.4,2.9c-2.2-2.4-5.3-3.8-8.6-3.8
      c-6.5,0-11.7,5.5-11.7,12c0,1,0,1.9,0.2,2.6C18.7,19.2,10.1,14.4,4.3,7c-1,1.7-1.7,3.8-1.7,6c0,4.1,2.2,7.9,5.3,10.1
      c-1.9,0-3.8-0.7-5.3-1.4v0.2c0,5.7,4.1,10.8,9.6,12c-1,0.2-1.9,0.5-3.1,0.5c-0.7,0-1.4,0-2.2-0.2c1.4,4.8,5.7,8.4,11,8.4
      c-4.1,3.4-9.1,5.3-14.6,5.3c-1,0-1.9,0-2.9-0.2c5.3,3.4,11.5,5.5,18.2,5.5c21.8,0,33.5-18.4,33.5-34.5v-1.7
      C54.1,15.3,56.1,13.2,57.5,10.8z'
    />
  </g>
);

export const SOCIAL_X = (
  <g>
    <path d='M8.31749 5.92941L13.4234 0H12.2293L7.7822 5.14706L4.24102 0H0.164551L5.51749 7.78235L0.164551 14H1.35867L6.05279 8.56471L9.75867 14H13.8351L8.31749 5.92941ZM6.62926 7.86471L6.09396 7.08235L1.81161 0.905882H3.66455L7.16455 5.88824L7.69984 6.67059L12.2293 13.1353H10.3763L6.62926 7.86471Z' />
  </g>
);
export const SOCIAL_SPOTIFY = (
  <g>
    <path d='M8 0.25C12.25 0.25 15.75 3.75 15.75 8C15.75 12.2812 12.25 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.75 3.71875 0.25 8 0.25ZM11.125 11.6562C11.375 11.6562 11.5938 11.4688 11.5938 11.1875C11.5938 10.9062 11.5 10.7812 11.3125 10.6562C9.0625 9.34375 6.46875 9.28125 3.90625 9.84375C3.65625 9.90625 3.46875 10.0625 3.46875 10.375C3.46875 10.625 3.65625 10.875 3.96875 10.875C4.0625 10.875 4.21875 10.8125 4.34375 10.7812C6.59375 10.3438 8.84375 10.375 10.8125 11.5625C10.9062 11.625 11 11.6562 11.125 11.6562ZM11.9688 9.625C12.3125 9.625 12.5625 9.34375 12.5938 9C12.5938 8.75 12.4688 8.53125 12.2188 8.40625C10.6875 7.46875 8.71875 6.96875 6.6875 6.96875C5.40625 6.96875 4.5 7.15625 3.625 7.40625C3.3125 7.5 3.15625 7.71875 3.15625 8.03125C3.15625 8.375 3.4375 8.65625 3.75 8.65625C3.90625 8.65625 3.96875 8.59375 4.125 8.5625C6.71875 7.875 9.625 8.34375 11.5938 9.5C11.6875 9.53125 11.8125 9.625 11.9688 9.625ZM12.9375 7.25C13.3125 7.25 13.6562 6.9375 13.6562 6.5C13.6562 6.125 13.5 5.9375 13.25 5.8125C11.5312 4.78125 9.125 4.3125 6.84375 4.3125C5.5 4.3125 4.28125 4.46875 3.1875 4.78125C2.90625 4.875 2.625 5.09375 2.625 5.53125C2.625 5.9375 2.9375 6.28125 3.34375 6.28125C3.5 6.28125 3.65625 6.21875 3.75 6.1875C6.34375 5.46875 10.3125 5.78125 12.5312 7.125C12.6875 7.1875 12.7812 7.25 12.9375 7.25Z' />
  </g>
);
export const SOCIAL_PODCAST = (
  <g>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M9.34375 15.2812C9.59375 14.375 10 12.1562 10 11.125C10 10.0312 9 9.75 8 9.75C6.96875 9.75 6 10.0312 6 11.125C6 12.1562 6.375 14.4062 6.625 15.2812C6.78125 15.875 7.40625 16 8 16C8.5625 16 9.1875 15.875 9.34375 15.2812ZM4.5 7.25C4.5 5.34375 6 3.8125 7.90625 3.78125C9.84375 3.71875 11.4688 5.3125 11.5 7.25C11.5 8.125 11.1875 8.9375 10.5938 9.59375C10.5625 9.65625 10.5312 9.75 10.5938 9.8125C10.75 10.0625 10.875 10.3125 10.9375 10.625C10.9688 10.75 11.125 10.8125 11.25 10.7188C12.1562 9.84375 12.75 8.625 12.75 7.25C12.7188 4.625 10.5625 2.46875 7.90625 2.53125C5.3125 2.5625 3.25 4.65625 3.25 7.25C3.25 8.625 3.8125 9.84375 4.71875 10.7188C4.84375 10.8125 5 10.75 5.03125 10.625C5.09375 10.3125 5.21875 10.0625 5.375 9.8125C5.4375 9.75 5.40625 9.65625 5.375 9.59375C4.78125 8.9375 4.5 8.125 4.5 7.25ZM8 0.03125C3.9375 0 0.65625 3.25 0.625 7.3125C0.59375 10.375 2.4375 13.0312 5.0625 14.1562C5.1875 14.2188 5.34375 14.0938 5.3125 13.9688C5.25 13.625 5.1875 13.25 5.15625 12.9062C5.15625 12.8438 5.09375 12.8125 5.0625 12.7812C3.1875 11.75 1.875 9.75 1.875 7.375C1.875 4 4.59375 1.25 8 1.25C11.375 1.25 14.125 4 14.125 7.375C14.125 9.71875 12.8125 11.75 10.9062 12.7812C10.875 12.8125 10.8125 12.8438 10.8125 12.9062C10.7812 13.25 10.7188 13.625 10.6562 13.9688C10.625 14.0938 10.7812 14.2188 10.9062 14.1562C13.5312 13.0312 15.375 10.4375 15.375 7.375C15.375 3.3125 12.0625 0.03125 8 0.03125ZM8 5C6.875 5 6 5.90625 6 7C6 8.125 6.875 9 8 9C9.09375 9 10 8.125 10 7C10 5.90625 9.09375 5 8 5Z'
    />
  </g>
);

export const SOCIAL_LINK = (
  <g>
    <path d='M10.8125 7.1875C10.4688 6.84375 10.0938 6.59375 9.6875 6.375C9.53125 6.3125 9.375 6.34375 9.25 6.46875L9.125 6.59375C8.84375 6.84375 8.6875 7.1875 8.65625 7.53125C8.625 7.6875 8.71875 7.84375 8.84375 7.9375C9.125 8.0625 9.375 8.21875 9.5625 8.4375C10.5938 9.46875 10.5938 11.125 9.5625 12.1562L7.21875 14.5C6.1875 15.5312 4.53125 15.5312 3.5 14.5C2.46875 13.4688 2.46875 11.8125 3.5 10.7812L4.9375 9.34375C5.03125 9.25 5.0625 9.125 5.03125 9C4.9375 8.625 4.90625 8.21875 4.875 7.8125C4.875 7.5 4.46875 7.34375 4.25 7.5625C3.875 7.9375 3.28125 8.53125 2.28125 9.53125C0.5625 11.25 0.5625 14.0312 2.28125 15.7188C3.96875 17.4375 6.75 17.4375 8.46875 15.7188C11.0312 13.1562 10.9062 13.2812 11.0938 13.0312C12.5 11.3438 12.4062 8.78125 10.8125 7.1875ZM15.6875 2.3125C14 0.59375 11.2188 0.59375 9.5 2.3125C6.9375 4.875 7.0625 4.75 6.875 5C5.46875 6.6875 5.5625 9.25 7.15625 10.8438C7.5 11.1875 7.875 11.4375 8.28125 11.6562C8.4375 11.7188 8.59375 11.6875 8.71875 11.5625L8.84375 11.4375C9.125 11.1875 9.28125 10.8438 9.3125 10.5C9.34375 10.3438 9.25 10.1875 9.125 10.0938C8.84375 9.96875 8.59375 9.8125 8.40625 9.59375C7.375 8.5625 7.375 6.90625 8.40625 5.875L10.75 3.53125C11.7812 2.5 13.4375 2.5 14.4688 3.53125C15.5 4.5625 15.5 6.21875 14.4688 7.25L13.0312 8.6875C12.9375 8.78125 12.9062 8.90625 12.9375 9.03125C13.0312 9.40625 13.0625 9.8125 13.0938 10.2188C13.0938 10.5312 13.5 10.6875 13.7188 10.4688C14.0938 10.0938 14.6875 9.5 15.6875 8.5C17.4062 6.78125 17.4062 4 15.6875 2.3125Z' />
  </g>
);

export const SOCIAL_LINKEDIN = (
  <g>
    <path
      d='M21.1,18.8h11.1v5.7h0.2c1.7-2.8,5.4-5.7,11.1-5.7c11.8,0,14,7.3,14,17v19.6H45.9V38c0-4,0-9.5-6.1-9.5
      s-7.1,4.5-7.1,9.2v17.5H21.1V18.8z M0.7,18.8h12.1v36.4H0.7V18.8z M12.8,8.7c0,3.3-2.8,6.1-6.1,6.1S0.5,12,0.5,8.7s2.8-6.1,6.1-6.1
      S12.8,5.3,12.8,8.7z'
    />
  </g>
);

export const SOCIAL_VODACOM = (
  <g>
    <path
      d='M29,0.5C13.3,0.5,0.5,13.3,0.5,29S13.3,57.5,29,57.5S57.5,44.7,57.5,29S44.7,0.5,29,0.5z M42.6,36.5
      C42,38,41,39.2,40,40.2l-1.2,1.2c-1.6,1.2-3.3,2-5.3,2.6c-1.4,0.4-2.8,0.6-4.1,0.6c-0.6,0-1,0-1.6-0.2c-0.8-0.2-1.6-0.2-2.4-0.4
      c-2.4-0.8-4.9-2-6.7-4.1c-0.8-0.8-1.4-1.6-2-2.4c-0.8-1.4-1.6-2.9-2-4.5l-0.2-0.4c-0.2-0.8-0.4-1.8-0.6-2.8c0-0.6-0.2-1.4-0.2-2v-1
      c0-1.4,0.2-2.6,0.6-4.1c1.2-4.9,4.1-9.4,7.9-12.6c2.2-1.8,4.7-3.5,7.7-4.5c0.8-0.2,1.6-0.6,2.2-0.8l1.4-0.4c1.2-0.2,2.4-0.6,3.7-0.6
      c0.6,0,1-0.2,1.4-0.2C38.4,3.8,38,3.8,37.8,4c-3.9,2-6.3,6.3-6.3,10.8v0.8h0.4c2.2,0.4,4.3,1.2,5.9,2.2c1.6,1,2.9,2,3.9,3.5l0.2,0.4
      c0.6,1,1.2,2.2,1.6,3.5c0.4,1.2,0.6,2.6,0.6,4.1v0.6C44.3,32.3,43.7,34.5,42.6,36.5z'
    />
  </g>
);

export const SOCIAL_YOUTUBE = (
  <g>
    <path
      d='M35.5,40v6.7c0,1.4-0.4,2.2-1.2,2.2c-0.4,0-1-0.2-1.4-0.8v-9.6c0.4-0.4,1-0.8,1.4-0.8
      C35.1,38,35.5,38.6,35.5,40z M46.3,40.2v1.4h-2.9v-1.4c0-1.4,0.4-2.2,1.4-2.2S46.3,38.6,46.3,40.2z'
    />
    <path
      d='M51.8,30c-0.2-1.2-0.8-2.2-1.8-3.1c-1-1-2.2-1.4-3.3-1.6c-3.9-0.4-9.8-0.6-17.7-0.6s-13.8,0.2-17.7,0.6
      C9.9,25.5,9,26.1,8,26.8c-0.8,0.8-1.4,2-1.8,3.1c-0.6,2.6-0.8,6.3-0.8,11.2c0,5.1,0.2,8.8,0.8,11.2C6.4,53.6,7,54.7,8,55.5
      c1,0.8,2.2,1.2,3.3,1.4c3.9,0.4,9.8,0.6,17.7,0.6s13.8-0.2,17.7-0.6c1.4,0,2.4-0.6,3.3-1.4c0.8-0.8,1.4-2,1.8-3.1
      c0.6-2.6,0.8-6.3,0.8-11.2C52.6,36.1,52.4,32.3,51.8,30z M18.8,33.1h-3.5v18.1h-3.1V33.1H8.8v-2.9h10
      C18.8,30.2,18.8,33.1,18.8,33.1z M27.4,51.2h-2.6v-1.8c-1.2,1.4-2.4,2-3.3,2c-1,0-1.6-0.4-1.8-1.2c-0.2-0.6-0.2-1.4-0.2-2.4V35.5
      h2.8v12.8c0,0.4,0.2,0.6,0.6,0.6c0.6,0,1.2-0.4,1.8-1.4v-12h2.8C27.4,35.5,27.4,51.2,27.4,51.2z M38.2,46.5c0,1.6,0,2.8-0.2,3.1
      c-0.2,1.2-1,1.8-2.2,1.8c-1,0-2-0.6-2.9-1.8v1.6h-2.8v-21h2.8v6.9c1-1.2,2-1.8,2.9-1.8c1,0,1.8,0.6,2.2,1.8
      c0.2,0.6,0.2,1.6,0.2,3.1V46.5z M49.2,44.1h-5.7v2.8c0,1.4,0.4,2.2,1.4,2.2c0.6,0,1-0.4,1.2-1.2v-2H49v2.2c0,0.6-0.2,1.2-0.6,1.8
      c-0.6,1.2-1.8,1.8-3.3,1.8c-1.4,0-2.6-0.4-3.3-1.6c-0.6-0.8-1-2-1-3.7v-5.5c0-1.8,0.4-2.9,1-3.7c0.8-1,2-1.6,3.3-1.6
      s2.6,0.4,3.3,1.6c0.6,0.8,0.8,2,0.8,3.7C49.2,40.8,49.2,44.1,49.2,44.1z M31.6,7.4c-0.8-1-2-1.6-3.3-1.6c-1.4,0-2.6,0.4-3.3,1.6
      c-0.6,0.8-1,2-1,3.7v5.5c0,1.8,0.4,2.9,1,3.7c0.8,1,2,1.6,3.3,1.6c1.4,0,2.6-0.4,3.3-1.6c0.6-0.8,1-2,1-3.7v-5.5
      C32.5,9.3,32.3,8.2,31.6,7.4z M29.8,17.2c0,1.4-0.6,2.2-1.4,2.2c-1,0-1.4-0.6-1.4-2.2v-6.7c0-1.4,0.4-2.2,1.4-2.2
      c1,0,1.4,0.8,1.4,2.2V17.2z M20.7,0.5h3.3l-3.9,12.8v8.6H17v-8.6c-0.4-1.6-1-3.7-2-6.7c-0.8-2.2-1.6-4.1-2.2-5.9h3.3l2.2,8.5
      C18.4,9.1,20.7,0.5,20.7,0.5z M43.3,6v15.9h-2.9v-1.8c-1.2,1.4-2.2,2-3.3,2c-1,0-1.6-0.4-2-1.2c-0.2-0.6-0.2-1.4-0.2-2.4V6h2.9
      v12.8c0,0.4,0.2,0.8,0.6,0.8c0.6,0,1.2-0.4,1.8-1.4V6H43.3z'
    />
  </g>
);

// ACTIONS

export const ACTION_SEARCH = (
  <g>
    <path
      d='M57 52.2c.7.7.7 1.7 0 2.4L54.6 57c-.7.7-1.7.7-2.4 0L34.9 39.9c-.2-.2-.2-.5-.5-.7-3.6 2.6-7.8 4-12.6
      4C10 43.2.5 33.7.5 21.9S10 .5 21.9.5 43.2 10 43.2 21.9c0 4.7-1.4 9-4 12.6.2 0 .5.2.7.5 0-.1 17.1 17.2 17.1
      17.2zM21.9 7.9C14 7.9 7.6 14.3 7.6 22.1S14 36.3 21.9 36.3s14.2-6.4 14.2-14.2S29.7 7.9 21.9 7.9z'
    />
  </g>
);

export const ACTION_CLOSE = (
  <g>
    <path
      d='M56.8,49.9c1,1,1,2.5,0,3.4l-3.4,3.4c-1,1-2.5,1-3.4,0L29,35.9L8.1,56.8c-1,1-2.5,1-3.4,0l-3.4-3.4
      c-1-1-1-2.5,0-3.4L22.1,29L1.2,8.1c-1-1-1-2.5,0-3.4l3.4-3.4c1-1,2.5-1,3.4,0L29,22.1L49.9,1.2c1-1,2.5-1,3.4,0l3.4,3.4
      c1,1,1,2.5,0,3.4L35.9,29L56.8,49.9z'
    />
  </g>
);

export const ACTION_CHEVRON_DOWN = (
  <g>
    <path
      d='M1 1L7 7L13 1'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </g>
);
